import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Market from "@/pages/market/page";
import Trading from "@/pages/trading/page";
import Assets from "@/pages/assets/page";
import Login from "@/pages/login/page";
import Profile from "@/pages/profile/page";
import Kyc from "@/pages/kyc/page";
import Bank from "@/pages/bank/page";
import Notifications from "@/pages/notifications/page";
import Support from "@/pages/support/page";
import CheckRequest from "@/pages/check-request/page";
import Dashboard from "@/pages/dashboard/page";
import Utilities from "@/pages/utilities/page";
import AdminUsers from "@/pages/admin/users/page";
import AdminDeposits from "@/pages/admin/deposits/page";
import AdminBanners from "@/pages/admin/banners/page";
import AdminLogs from "@/pages/admin/logs/page";
import AdminSupport from "@/pages/admin/support/page";
import RequireAuth from "@/components/feature/RequireAuth";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/thi-truong", element: <RequireAuth><Market /></RequireAuth> },
  { path: "/giao-dich", element: <RequireAuth><Trading /></RequireAuth> },
  { path: "/tai-san", element: <RequireAuth><Assets /></RequireAuth> },
  { path: "/dang-nhap", element: <Login /> },
  { path: "/ho-so", element: <RequireAuth><Profile /></RequireAuth> },
  { path: "/xac-minh-danh-tinh", element: <RequireAuth><Kyc /></RequireAuth> },
  { path: "/ngan-hang", element: <RequireAuth><Bank /></RequireAuth> },
  { path: "/thong-bao", element: <RequireAuth><Notifications /></RequireAuth> },
  { path: "/ho-tro", element: <Support /> },
  { path: "/kiem-tra-yeu-cau", element: <CheckRequest /> },
  { path: "/bang-dieu-khien", element: <RequireAuth><Dashboard /></RequireAuth> },
  { path: "/tien-ich", element: <Utilities /> },
  { path: "/quan-tri/nguoi-dung", element: <AdminUsers /> },
  { path: "/quan-tri/nap-rut", element: <AdminDeposits /> },
  { path: "/quan-tri/banner-tin-tuc", element: <AdminBanners /> },
  { path: "/quan-tri/nhat-ky", element: <AdminLogs /> },
  { path: "/quan-tri/ho-tro", element: <AdminSupport /> },
  { path: "*", element: <NotFound /> },
];

export default routes;